import React from 'react'
import { Button } from '@enamelai/design-system'
import { Icon as EditIcon } from '@enamelai/design-system/icons/Edit'

type UpdateViewButtonProps = {
  handleSaveView: (viewId?: string) => Promise<void>
  selectedViewId: string
}

const UpdateViewButton = ({
  handleSaveView,
  selectedViewId,
}: UpdateViewButtonProps): React.ReactElement => (
  <Button
    variant="secondary"
    size="md"
    className="reports-view-action-button"
    leftIcon={<EditIcon className="reports-view-action-icon" aria-hidden />}
    aria-label="Update this view"
    title="Update this view"
    onClick={() => handleSaveView(selectedViewId)}
  />
)

export default UpdateViewButton
